import React, { useEffect, useRef } from "react"
import { storyblokEditable } from "gatsby-source-storyblok"


const SignupForm = ({blok}) => {
  // console.log(blok)
  
  // another approach to fetch form code, but need put signup form code in /static/signup.form
  // const [formCode, setFormCode] = useState(null);
  // useEffect(() => {
  //   fetch("/signup.form")
  //   .then((r) => r.text())
  //   .then(text  => {console.log(text); setFormCode(text); })
  // } ,[])

  const bgImge = blok.bgImage?.filename ? `url(${blok.bgImage?.filename})` : 'none'


  const formRef = useRef(null)
  useEffect(() => {
    const formCode = blok.code?.replace("display:inline;", "display:flex;")
      .replace(' width: 320px;', '')
      .replace('padding: 15px;', 'padding: 15px; padding-bottom: 12px;')  // change layout input and button in same line
    formRef.current.innerHTML = formCode

    // load benchmarkemail signup scripts
    const parser = new DOMParser()
    const htmlDoc = parser.parseFromString(formCode, 'text/html')
    const scripts = htmlDoc.getElementsByTagName('script')
    var scriptTags = []
    for (let script of scripts) {
      const scriptTag = document.createElement('script')
      scriptTag.innerHTML = script.innerHTML
      document.body.appendChild(scriptTag)
      scriptTags.push(scriptTag)
    }
    return () => {
      for (let scriptTag of scriptTags) {
        scriptTag.remove()
      }
    }
  }, [])

  return (
    <section {...storyblokEditable(blok)} className="container mx-auto flex flex-col items-center justify-center bg-cover bg-center pt-6" 
      style={{ 'backgroundImage': `${bgImge}` }}>
      <h2 className="font-bold text-3xl md:text-4xl my-6 text-cenater">{blok.title}</h2>
      <p className="text-center">{blok.description}</p>
      
      <div id="signup-form" ref={formRef} />

      <div className="flex flex-row items-center justify-center my-8 gap-4">
        {blok.facebook?.cached_url && <a href={blok.facebook.cached_url} target="_blank" rel="noreferrer"><img src="/icons/sns-facebook.svg" alt="Facebook" /></a>}
        {blok.instagram?.cached_url && <a href={blok.instagram.cached_url} target="_blank" rel="noreferrer"><img src="/icons/sns-instagram.svg" alt="Instagram"/></a>}
        {blok.twitter?.cached_url && <a href={blok.twitter?.cached_url} target="_blank" rel="noreferrer"><img src="/icons/sns-x-twitter.svg" alt="Twitter" /></a>}
        {blok.line?.cached_url && <a href={blok.line?.cached_url} target="_blank" rel="noreferrer"><img src="/icons/sns-line.svg" alt="LINE"/></a>}
        {blok.youtube?.cached_url && <a href={blok.youtube?.cached_url} target="_blank" rel="noreferrer"><img src="/icons/sns-youtube.svg" alt="Youtube"/></a>}
      </div>
    </section>
  )
}
  
export default SignupForm
